import { render, staticRenderFns } from "./Sclcarrom.vue?vue&type=template&id=50a942b1&scoped=true&"
import script from "./Sclcarrom.vue?vue&type=script&lang=ts&"
export * from "./Sclcarrom.vue?vue&type=script&lang=ts&"
import style0 from "./Sclcarrom.vue?vue&type=style&index=0&id=50a942b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a942b1",
  null
  
)

component.options.__file = "Sclcarrom.vue"
export default component.exports